import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useEnableUpgradePlanPromotionalBanner = () => {
  return useFeatureFlag(FeatureFlagDeclarations.enableUpgradePlanPromotionalBanner);
};
